import Application from "../../Application";
import GetAllGenericAttachmentTypesInteractor from "../../attachmentType/interactor/GetAllGenericAttachmentTypesInteractor";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import { ContentTypes } from "../../portal/common/Constants";
import LegalViewDetailsPresenter, {
  ILegalViewDetailsPresenter
} from "../presenter/LegalViewDetailsPresenter";
import { TLegalViewPresentationModel } from "../presenter/model/LegalViewPresentationModel";
import FindLegalViewInteractor from "./FindLegalViewInteractor";
import GetAllLegalViewTypesInteractor from "./GetAllLegalViewTypesInteractor";
import GetAttachmentsForLegalViewsInteractor from "./GetAttachmentsForLegalViewsInteractor";
import GetLegalViewIndexesInteractor from "./GetLegalViewIndexesInteractor";

export default class ShowLegalViewDetailsInteractor {
  private application: Application;
  private output?: ILegalViewDetailsPresenter;
  private findLegalViewInteractor: FindLegalViewInteractor;
  private getAllLegalViewTypesInteractor: GetAllLegalViewTypesInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getLegalViewIndexesInteractor: GetLegalViewIndexesInteractor;
  private getAllGenericAttachmentTypesInteractor: GetAllGenericAttachmentTypesInteractor;
  private getAttachmentsForLegalViewsInteractor: GetAttachmentsForLegalViewsInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;

  constructor({
    application,
    findLegalView,
    getAllLegalViewTypes,
    getAllOrganisations,
    getLegalViewIndexes,
    getAllGenericAttachmentTypes,
    getAttachmentsForLegalViews,
    getGenericCodebook
  }) {
    this.application = application;
    this.findLegalViewInteractor = findLegalView;
    this.getAllLegalViewTypesInteractor = getAllLegalViewTypes;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getLegalViewIndexesInteractor = getLegalViewIndexes;
    this.getAllGenericAttachmentTypesInteractor = getAllGenericAttachmentTypes;
    this.getAttachmentsForLegalViewsInteractor = getAttachmentsForLegalViews;
    this.getGenericCodebookInteractor = getGenericCodebook;
  }

  private async getAllLegalViewTypes() {
    return this.getAllLegalViewTypesInteractor.execute();
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }
  private async getAllGenericAttachmentTypes() {
    return this.getAllGenericAttachmentTypesInteractor.execute();
  }
  private async getAttachmentsForLegalViews(legalViewId: number) {
    return this.getAttachmentsForLegalViewsInteractor.execute(legalViewId);
  }
  private async getGenericCodebook() {
    return this.getGenericCodebookInteractor.execute(
      ContentTypes.ATTACHMENT_CONTENT_TYPE,
      false
    );
  }

  private async getReferenceLists(legalViewId: number) {
    return Promise.all([
      this.getAllLegalViewTypes(),
      this.getAllOrganisations(),
      this.getAllGenericAttachmentTypes(),
      this.getAttachmentsForLegalViews(legalViewId),
      this.getGenericCodebook()
    ]);
  }

  execute(id: number) {
    this.output = LegalViewDetailsPresenter({
      application: this.application,
      initialState: {
        legalView: {} as TLegalViewPresentationModel,
        organisations: [],
        legalViewTypes: [],
        legalViewIndexes: [],
        indexHierarchyList: [],
        attachmentContentTypes: [],
        attachmentTypes: [],
        attachments: [],
        anonimisedUploadedFile: undefined
      }
    });
    this.findLegalViewInteractor.execute(id).then((legalView) => {
      this.getReferenceLists(legalView.id)
        .then(
          ([
            legalViewTypes,
            organisations,
            attachmentTypes,
            attachments,
            attachmentContentTypes
          ]) =>
            this.output?.loadReferenceValues(
              legalViewTypes,
              organisations,
              attachmentTypes,
              attachments,
              attachmentContentTypes
            )
        )
        .then(() => this.output?.loadLegalView(legalView))
        .then(() => this.getLegalViewIndexesInteractor.execute(id))
        .then((organisationIndex) =>
          this.output?.loadLegalViewIndexes(organisationIndex)
        );
    });
    return this.output;
  }
}
